<template>
    <intranet-nav-content>
        <template slot="links">
            <intranet-nav-content-link-exact :link="{ name: 'Home', path: { name: 'admin-dashboard' } }"/>
            <!-- <intranet-nav-content-link :link="{ name: 'test', path: { name: 'admin-dashboard-test' } }"/> -->
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';
// import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';

export default {
    name: 'AdminDashboard',
    components: { 
        IntranetNavContent,
        IntranetNavContentLinkExact,
        // IntranetNavContentLink
    },
};
</script>
